import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timi-employeegroup-container" }
const _hoisted_2 = { class: "timi-employeegroup-detail-content" }
const _hoisted_3 = { class: "timi-detailgroup-column column-grow" }
const _hoisted_4 = { class: "timi-employeegroup-profile-head" }
const _hoisted_5 = { class: "ww-data-list-item" }
const _hoisted_6 = { class: "ww-data-list-item" }
const _hoisted_7 = { class: "ww-data-list-item" }
const _hoisted_8 = { class: "ww-data-list-item" }
const _hoisted_9 = { class: "ww-card-actions" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "ww-verticale-divider" }, null, -1)
const _hoisted_11 = { class: "timi-detail-column" }
const _hoisted_12 = { class: "timi-employeegroup-profile-head" }
const _hoisted_13 = { class: "list-rights" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "timi-detail-column" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_DataList = _resolveComponent("DataList")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_IconButton, {
      icon: _ctx.store.getters.svgIcons.arrowbackward,
      class: "go-back-btn",
      label: _ctx.$t('button.back'),
      dense: true,
      onOnClick: _ctx.handleGoBack
    }, null, 8, ["icon", "label", "onOnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Card, {
          class: "timi-employeegroup-profile",
          contentLoading: !_ctx.employeegroup.uid
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.employeegroup.title), 1)
            ]),
            _createVNode(_component_DataList, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.employeegroupTitle')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.employeegroup.title), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.employeegroupSystemGroup')), 1),
                  _createVNode(_component_Switch, {
                    class: "active-switch",
                    mini: true,
                    name: "systemGroup",
                    disabled: true,
                    value: _ctx.employeegroup.systemGroup
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.employeegroupIsAdmin')), 1),
                  _createVNode(_component_Switch, {
                    class: "active-switch",
                    mini: true,
                    name: "isAdmin",
                    disabled: true,
                    value: _ctx.employeegroup.isAdmin
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.employeegroupIsDefault')), 1),
                  _createVNode(_component_Switch, {
                    class: "active-switch",
                    mini: true,
                    name: "isDefault",
                    disabled: true,
                    value: _ctx.employeegroup.isDefault
                  }, null, 8, ["value"])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Button, {
                text: _ctx.$t('button.edit'),
                dense: true,
                onOnClick: _ctx.handleEdit
              }, null, 8, ["text", "onOnClick"]),
              _hoisted_10,
              _createVNode(_component_Button, {
                text: _ctx.$t('button.delete'),
                dense: true,
                onOnClick: _ctx.handleConfirmDeleteProject
              }, null, 8, ["text", "onOnClick"])
            ])
          ]),
          _: 1
        }, 8, ["contentLoading"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Card, {
          class: "timi-employeegroup-profile",
          contentLoading: !_ctx.employeegroup.uid
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('label.employeegroupRights')), 1),
              _createElementVNode("ul", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employeegroup.getRightsArray(), (right) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: right.uid
                  }, _toDisplayString(right.title), 1))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["contentLoading"])
      ]),
      _hoisted_14
    ])
  ]))
}